/**
 * 接口文档
 * http://192.168.3.101/webot-dev/webot3/blob/xuwei/doc/api/H5.md#%E7%95%99%E8%A8%80-post-chatmessage
 */

import request from '@/utils/request'

/**
 * 留言
 * @param { Object } data
 * @param { String } data.uid - 用户 id
 * @param { Number } [data.tag] - tagId
 * @param { String } data.desc - 描述问题的内容
 * @param { String } [data.email]
 * @param { String } [data.mobile]
 * @param { Object[] } data.uploads - 上传附件数组 [{ url, name, size, type }]
 */
export function postLeaveMessage ({
    uid,
    tag,
    desc,
    name,
    email,
    mobile,
    uploads
}) {
    return request({
        url: 'chat/message',
        method: 'post',
        data: {
            chat_user_id: uid,
            description: desc,
            tag,
            name,
            email,
            mobile,
            uploads
        }
    })
}

/**
 * 获取留言的标签
 * @param { String } entryKey
 */
export function getServiceTag (entryKey) {
    return request({
        url: 'company_setting/service_tag',
        method: 'get',
        params: {
            e: entryKey
        }
    })
}

export function getLeaveMsgConf (params) {
    return request({
        url: 'company_setting/simple?name=leave_message',
        method: 'get',
        params
    })
}
